import { createStore, combineReducers } from 'redux';
import { USER_SET_DATA, USER_CLEAR_DATA, TOGGLE_CONNECTEDUSERS_BAR, CHANGE_BACKGROUND } from './actions';
import { loadStorageState, localStorageSaveState } from './localstorage';

const user = {
    name: '',
    avatar: '',
    publicId: '',
    rolX: '',
    status: false
}

const ui = { 
    connectedUsersBarShow:  true,
    backgroundImage: 1
}

function userReducer( state = user, action){
    switch (action.type) {
        case USER_SET_DATA :
            return  action.payload ;
        case USER_CLEAR_DATA :
            return user;
        default:
            return state;
    }
}

function uiReducer (state = ui, action){
    switch(action.type){
        case TOGGLE_CONNECTEDUSERS_BAR:
            return {...state, connectedUsersBarShow: !state.connectedUsersBarShow};
        case CHANGE_BACKGROUND:
            return {...state, backgroundImage: action.payload}
        default: 
            return state;
    }
}

const persistedState = loadStorageState();

let store = createStore( 
    combineReducers({
        ui: uiReducer, 
        user: userReducer
    }), 
    persistedState ? persistedState : {user, ui} 
);   

store.subscribe(()=>{
    console.log('redux store: ',store.getState())
    localStorageSaveState(store.getState())
})

export default store;

